import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

import { useReseller } from 'hooks/Reseller/useReseller';
import { NotFoundPage } from '../ErrorPage/NotFoundPage';

type IPartnerBump = RouteComponentProps<{ partnerName: string }>;

export function buildRedirectPath(pathname: string, partnerName: string) {
  return `/shop${pathname.replace(new RegExp(`^\/partner\/${partnerName}`), '')}?partner=${partnerName}`;
}

const PartnerBump: React.FC<IPartnerBump> = ({ match, location }) => {
  const { contentfulReseller, resellerRedirectUrl, referrerDomains, setReferralHostId } = useReseller();
  const { pathname } = location;
  const { params } = match;

  if (!contentfulReseller) return <NotFoundPage />;
  if (resellerRedirectUrl) window.location.assign(resellerRedirectUrl);

  const [firstReferrerDomain] = referrerDomains;
  if (firstReferrerDomain) setReferralHostId(firstReferrerDomain);

  return <Redirect to={buildRedirectPath(pathname, params.partnerName)} />;
};

const Routed = withRouter(PartnerBump);
type Routed = typeof Routed;

export { Routed as PartnerBump };
